import { rgb } from 'pdf-lib';
import { DocumentElement } from './document-element.model';

export const DefaultConfiguration: DocumentElement = {
  protocol: {
    x: 35,
    y: 310,
    rotate: 90,
    size: 10,
    color: rgb(0, 0, 0),
    page: [],
    type: 'text',
    family: 'calibri',
    font: 'regular',
    height: 0,
    width: 0,
    adjustBy: 'height',
  },
  orgName: {
    x: 15,
    y: 310,
    rotate: 90,
    size: 10,
    color: rgb(0, 0, 0),
    page: [],
    type: 'text',
    family: 'calibri',
    font: 'regular',
    height: 0,
    width: 0,
    adjustBy: 'height',
  },
  type: {
    x: 20,
    y: 503,
    rotate: 90,
    size: 22,
    color: rgb(0, 0, 0),
    page: [],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
  },
  protocolRectName: {
    x: 3,
    y: 300,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [],
    type: 'rectangle',
    family: 'calibri',
    font: 'regular',
    height: 200,
    width: 20,
    adjustBy: 'height',
  },
  protocolRectType: {
    x: 3,
    y: 500,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [],
    type: 'rectangle',
    family: 'calibri',
    font: 'regular',
    height: 20,
    width: 20,
    adjustBy: 'height',
  },
  protocolRectDesc: {
    x: 23,
    y: 300,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [],
    type: 'rectangle',
    family: 'calibri',
    font: 'regular',
    height: 220,
    width: 20,
    adjustBy: 'height',
  },
};
